module.exports = __webpack_public_path__ + "img/clock.678dcbf2.svg";